import React from "react";

const ButtonList = ({ title, children }) => {
    return (
        <div className="col-span-2 border border-ec-border rounded-xl w-[310px] h-full">
            <div className="border-b border-ec-border p-6">
                <h3 className="font-inter font-semibold text-xl text-left">
                    {title} Report
                </h3>
            </div>

            <div className="p-6 h-[650px] overflow-y-scroll flex gap-2 flex-col">{children}</div>
        </div>
    );
};

export default ButtonList;
